import { RepositoryFactory } from "repositories/factory";
import { MonitoringTarget } from "models/monitoring-target";
import {
  MonitoringTargetsStoreValidator,
  MonitoringTargetsUpdateValidator,
  MonitoringTargetsImageUploadValidator,
} from "validators/monitoring-targets";

const MonitoringTargetsRepository = RepositoryFactory.get("monitoring-targets");

/* フォームアイテム */
class MonitoringTargetsController {
  constructor() {
    this._monitoringTarget = new MonitoringTarget();
  }

  get monitoringTarget() {
    return this._monitoringTarget;
  }

  set monitoringTarget(value) {
    this._monitoringTarget = value;
  }

  /* 算出プロパティ */
  /* イベントハンドラ */
  /* 初期化・登録処理 */
  static async createInstance(organizationId, projectId, monitoringTargetId = null) {
    // 初期化(DBの値をフォーム反映)
    const monitoringTargetController = new MonitoringTargetsController();
    let monitoringTarget = null;

    // データが存在しない場合
    if (!monitoringTargetId) {
      monitoringTarget = new MonitoringTarget(projectId);
      monitoringTarget.organizationId = organizationId;
    } else {
      monitoringTarget = await MonitoringTargetsRepository.get(
        projectId,
        monitoringTargetId,
      );
    }
    monitoringTargetController.monitoringTarget = monitoringTarget;
    return monitoringTargetController;
  }

  upsertValidate() {
    if (!this.monitoringTarget.isRegisterd()) {
      // 登録
      return MonitoringTargetsStoreValidator.validate(
        this.monitoringTarget,
      );
    }
    // 更新
    return MonitoringTargetsUpdateValidator.validate(
      this.monitoringTarget,
    );
  }

  // 登録/更新
  async upsert() {
    const updateItem = await MonitoringTargetsRepository.upsert(
      this.monitoringTarget,
    );
    this.monitoringTarget = updateItem;
  }

  // 削除処理
  async destroy() {
    await MonitoringTargetsRepository.destroy(
      this.monitoringTarget.projectId,
      this.monitoringTarget.monitoringTargetId,
    );
    this.monitoringTarget = null;
  }
}

class UploadImageFileController {
  constructor() {
    this._imagePath = null;
    this._imageFileUrl = null;
    this._imageFile = null;
  }

  get imagePath() {
    return this._imagePath;
  }

  set imagePath(value) {
    this._imagePath = value;
  }

  get imageFileUrl() {
    return this._imageFileUrl;
  }

  set imageFileUrl(value) {
    this._imageFileUrl = value;
  }

  get imageFile() {
    return this._imageFile;
  }

  set imageFile(value) {
    this._imageFile = value;
  }

  /* 算出プロパティ */
  isImageFileUpload() {
    // 画像ファイルが設定されている
    return !!this.imageFile;
  }

  isImageFileDelete() {
    // 画像登録されていたが、現在画面に反映されていない
    return !this.imageFileUrl && !!this.imagePath;
  }

  isSelected() {
    // 画像のURL設定されている
    return !!this.imageFileUrl;
  }

  /* インスタンス生成 */
  static createInstance(monitoringTarget = null) {
    const uploadImageFileController = new UploadImageFileController();
    if (monitoringTarget) {
      uploadImageFileController.imageFileUrl = monitoringTarget.getImageFileUrl();
      uploadImageFileController.imagePath = monitoringTarget.imagePath;
    }
    return uploadImageFileController;
  }

  /* フォーム操作によるプロパティの変更 */
  selectImageFile(imageFile) {
    console.log(imageFile);
    this.imageFile = imageFile;
    this.imageFileUrl = URL.createObjectURL(imageFile);
  }

  clearImageFile() {
    this.imageFileUrl = null;
    this.imageFile = null;
  }

  uploadValidate() {
    if (this.isImageFileUpload()) {
      //　画像アップロードあり
      return MonitoringTargetsImageUploadValidator.validate(
        this.imageFile,
      );
    }
    return new MonitoringTargetsImageUploadValidator();
  }

  async uploadImageFile(monitoringTarget) {
    if (this.isImageFileUpload()) {
      const updateItem = await MonitoringTargetsRepository.uploadImageFile(
        monitoringTarget,
        this.imageFile,
      );
      this.imageFileUrl = updateItem.getImageFileUrl();
      this.imagePath = updateItem.imagePath;
      this.imageFile = null;
      return updateItem;
    }
    return monitoringTarget;
  }

  async deleteImageFile(monitoringTarget) {
    console.log(monitoringTarget);
    if (this.isImageFileDelete()) {
      const updateItem = await MonitoringTargetsRepository.deleteImageFile(
        monitoringTarget,
      );
      this.imageFileUrl = updateItem.getImageFileUrl();
      this.imagePath = updateItem.imagePath;
      this.imageFile = null;
      return updateItem;
    }
    return monitoringTarget;
  }
}

export {
  MonitoringTargetsController,
  UploadImageFileController,
};
